import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var SearchPosListCtrl = function (fn, er, token, ids) {

    var config = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/json',
            'MT_SESSION_ID': ids
        },
    };
    let data = {}

    axios
        .post(ApiConfig.url.SEARCH_POS_LIST, data, config)
        .then(function (result) {
            fn(result.data, result.status)
        })
        .catch(function (error) {
            er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
        });
}

export { SearchPosListCtrl };